import * as React from 'react';

const DIGIT_HEIGHT = 40;

const DigitColumn = ({ digit, delay }: { digit: number; delay: number }) => {
  const [current, setCurrent] = React.useState(0);

  React.useEffect(() => {
    const t = setTimeout(() => setCurrent(digit), delay);
    return () => clearTimeout(t);
  }, [digit, delay]);

  return (
    <div style={{ width: 18, height: DIGIT_HEIGHT, overflow: 'hidden' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          transform: `translateY(-${current * DIGIT_HEIGHT}px)`,
          transition: 'transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
          <span
            key={d}
            style={{
              height: DIGIT_HEIGHT,
              lineHeight: `${DIGIT_HEIGHT}px`,
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
              fontWeight: 400,
              fontSize: '1.5rem',
              letterSpacing: '0em',
              display: 'block',
              textAlign: 'center',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {d}
          </span>
        ))}
      </div>
    </div>
  );
};

export const AnimatedNumber = ({ value }: { value: number }) => {
  const digits = String(value).split('').map(Number);

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: DIGIT_HEIGHT,
        margin: 0,
        lineHeight: 1.334,
      }}
    >
      {digits.map((d, i) => (
        <DigitColumn key={`${digits.length}-${i}`} digit={d} delay={i * 60} />
      ))}
    </div>
  );
};
